/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Header component
 * @author Dustin Gage
 */

import React, { memo, ReactElement } from "react";

import { LocaleChoice } from "./LocaleChoice";
import { SiteImage } from "../SiteImage";
import { useSettings } from "../../api/use-settings";
import { getString } from "../../api/get-string";
import { StringResource } from "../StringResource";
import { hasAtLeastOneQueryStringParameter } from "../../api/has-at-least-one-query-string-parameter";

interface IProps {}

export const Header = memo(function Header(props: IProps): ReactElement {
	const {} = props;
	const { HomeLinkAriaLabel } = StringResources.covidtriage;
	const { sitePath, headerLogo, locales } = useSettings();
	var { isHomeButtonHidden } = useSettings();

	if (!isHomeButtonHidden) {
		const { href } = window.location;
		const keys =  ["id","vt","dept","accessCode","sourceToken","linkSource"];
		isHomeButtonHidden = hasAtLeastOneQueryStringParameter(href,keys);
	}
	
	const homeLinkAriaLabel = getString(HomeLinkAriaLabel);

	const hasHeaderLogo = !!headerLogo && !!headerLogo.image && !!headerLogo.url;

	const hasMultipleLocales = Object.keys(locales).length > 1;

	return (
		<>
			<div className="navbar navbar-light bg-white shadow fixed-top">
				<div id="NavContainer" className="container d-flex justify-content-between">
					{!isHomeButtonHidden && (
						<a
							href={`${sitePath}`}
							id="HomeLink"
							className="btn btn-outline-dark"
							aria-label={homeLinkAriaLabel}
						>
							<span className="home-text">
								<StringResource token={StringResources.covidtriage.HomeLinkText} />
							</span>
						</a>
					)}
					<div
						id="NavLogoContainer"
						className={`navbar-section d-flex ${hasMultipleLocales ? "nav-centered" : ""}`}
					>
						<a className="nav-link" href="https://www.epic.com/">
							<SiteImage localPath="public/images/epic_logo_large.jpg" />
						</a>
						{hasHeaderLogo && (
							<a className="nav-link" href={headerLogo.url}>
								<SiteImage localPath={"custom/images/" + headerLogo.image} />
							</a>
						)}
					</div>

					{hasMultipleLocales ? (
						<div className="navbar-section">
							<LocaleChoice />
						</div>
					) : (
						void 0
					)}
				</div>
			</div>
		</>
	);
});
